import { isEmpty, find, includes, findIndex, get } from 'lodash';
import {
  transformAnswersForADL,
  transformValuesToString,
  encodeTextAnswers,
} from './utils';
import { TRANSFORMATION_DATA_TYPE_JSON } from './constants';
import request from './request';

Pollfish.screening = (function screening() {
  let screeningQuestions = [];
  let answeredQuestions = [];
  let savedAnswers = [];
  let hasAnsweredAllQuestions = false;
  return {
    setQuestions(questions = []) {
      screeningQuestions = questions.filter(({ isScreening }) => isScreening);
      if (isEmpty(questions)) {
        hasAnsweredAllQuestions = true;
      } else {
        hasAnsweredAllQuestions = false;
      }
      // we can refrain from deleting those if we want to keep history
      savedAnswers = [];
      answeredQuestions = [];
    },
    reset() {
      answeredQuestions = [];
      savedAnswers = [];
      hasAnsweredAllQuestions = false;
      if (isEmpty(screeningQuestions)) {
        hasAnsweredAllQuestions = true;
      } else {
        hasAnsweredAllQuestions = false;
      }
      // we can refrain from deleting those if we want to keep history
      savedAnswers = [];
      answeredQuestions = [];
    },
    getQuestions() {
      return screeningQuestions;
    },
    isPending() {
      return !isEmpty(screeningQuestions) && !hasAnsweredAllQuestions;
    },
    isCompleted() {
      return isEmpty(screeningQuestions) || hasAnsweredAllQuestions;
    },
    getNextQuestion() {
      const pendingQuestion = find(
        screeningQuestions,
        (question) => !includes(answeredQuestions, question.refId),
      );
      return pendingQuestion;
    },
    getQuestionByRefId(refId) {
      return find(screeningQuestions, ['refId', refId]);
    },
    getQuestionById(id) {
      return find(screeningQuestions, ['id', id]);
    },
    getAnswersCount() {
      return answeredQuestions.length;
    },
    saveAnswer(requestObject, question, answers) {
      // NOTE: we can check here if a user has already answered the given question!
      // or at least if we know it since we keep it in-memory
      const answeredQuestion = requestObject.q_ref_id;
      if (!answeredQuestion) {
        throw new Error('Missing answered question refId from request object');
      }

      this.setQuestionAnswersForScreeningPreview();
      // we save these answers so that the backend will receive them all together
      // but the backend expects their values as strings s_id, ttc etc
      savedAnswers.push(
        encodeTextAnswers(transformValuesToString(requestObject)),
      );
      answeredQuestions.push(answeredQuestion);

      if (answeredQuestions.length === screeningQuestions.length) {
        hasAnsweredAllQuestions = true;
      }

      const knowledge = Pollfish.store.getRespondentKnowledge();
      const transformedAnswers = transformAnswersForADL({
        question,
        answers,
      });
      knowledge.screeningQuestionAnswers.push({
        questionId: question.refId,
        answers: transformedAnswers,
      });

      // send the selected answer to the server
      request({
        url: '/v2/device/save/answers',
        method: 'POST',
        contentType: 'application/json; charset=utf-8',
        transformData: true,
        transformationDataType: TRANSFORMATION_DATA_TYPE_JSON,
        data: requestObject,
      });
    },
    getStoredAnswers() {
      return savedAnswers;
    },
    // if we are in preview mode with refId we need to fill
    // the answers for the previous screening questions
    // in order to avoid issues with getNextHelperQuestion
    setQuestionAnswersForScreeningPreview() {
      if (Pollfish.helper.isPreviewFromScreeningQuestion) {
        const refId = Pollfish.helper.getURLParameter('head_refId');
        const questionIndex = findIndex(this.getQuestions(), ['refId', refId]);
        for (let index = 0; index < questionIndex; index += 1) {
          const qRefId = get(this.getQuestions()[index], 'refId', '');
          if (isEmpty(savedAnswers[index])) {
            savedAnswers[index] = {};
          }
          if (isEmpty(answeredQuestions[index])) {
            answeredQuestions[index] = qRefId;
          }
        }
      }
    },
  };
})();

export default Pollfish.screening;
